module.exports = __webpack_public_path__ + "img/Flag_of_Kuwait.8080bda6.svg";